import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { FieldProps } from "@/app/servers/types";

const handleIdChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  onChange: (value: string) => void
) => {
  const value = e.target.value.toLowerCase().replace(/[^a-z0-9_-]/g, "");
  onChange(value);
};

export const IdField = ({ form, canUpdate }: FieldProps) => (
  <FormField
    control={form.control}
    name="id"
    render={({ field }) => (
      <FormItem>
        <FormLabel>ID</FormLabel>
        <FormControl>
          <Input
            disabled={!canUpdate}
            placeholder="my-provider"
            {...field}
            onChange={(e) => handleIdChange(e, field.onChange)}
          />
        </FormControl>
        <FormDescription>
          Unique identifier limited to lowercase, numbers, underscores, and
          hyphens.
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
);
